export default __webpack_public_path__ + "static/safari-626bb9d90e5f65d625b15d3d2cd7424c.svg";